import React from 'react';
import Header from '../../components/layout/Header';
import ReportCatalog from '../../components/reports/ReportCatalog';

export default function Reports() {
  return (
    <div className="flex-1 flex flex-col min-h-0">
      <Header title="Reports" breadcrumbs={[{ workspace: true }, { label: 'Reports' }]} />
      <main className="flex-1 overflow-auto p-6 pb-20 md:pb-6">
        <ReportCatalog />
      </main>
    </div>
  );
}
